import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
export default class AltDown extends Helper {
  @service modifierKeys;

  compute() {
    return this.modifierKeys.alt;
  }
}
